<template>
  <div class="stage-modal">
    <div class="stage-modal__block">
      <div class="stage-modal__button-parent"
           id="stage-modal__button-parent"
          @click="cancel()"
          @keydown.esc="cancel()">
        <span class="stage-modal__button">X</span>
      </div>
      <div
        class="form-group"
      >
        <label>
          {{ $t("Стадия") }}:
        </label>
        <v-select
              id="developer"
              item-value="id"
              item-text="transName"
              :items="stages"
              v-model="stageSelected"
              @change="changeStage"
              input="transName"
              outlined
              rounded
              dense
        ></v-select>
      </div>
      <div v-if="form.length > 0">
        <div
          v-for="(item, index) in form"
          class="form-item"
          :key="index"
        >
          <div class="stage-modal__button-parent"
          v-if="addStage && form.length > 1">
            <span
              class="stage-modal__button"
              @click="removeItem(index)"
            >X</span>
          </div>
          <div v-if="item.norm_stage == 1">
            <div
              class="form-group"
            >
              <label>
                {{ $t("Дата") }}:
              </label>
              <BaseDate
                v-model="item.date"
              />
            </div>
            <div
              class="form-group"
            >
              <label>
                {{ $t("Причина") }}:
              </label>
              <v-textarea
                v-model="item.reason"
                outlined
              />
            </div>
          </div>
          <div v-if="item.norm_stage == 2">
            <div
              class="form-group"
            >
              <label>
                {{ $t("Дата начала разработки") }}:
              </label>
              <BaseDate
                v-model="item.date"
              />
            </div>
            <div
              class="form-group"
            >
              <label>
                {{ $t("Вид ПЗА") }}:
              </label>
              <v-select
                  id="developer"
                  item-value="transName"
                  item-text="transName"
                  :items="kindByLaws"
                  v-model="item.kind_by_law"
                  input="transName"
                  outlined
                  rounded
                  dense
              ></v-select>
            </div>
          </div>
          <div v-if="item.norm_stage == 3">
            <div
              class="form-group"
            >
              <label>
                {{ $t("Дата публикации") }}:
              </label>
              <BaseDate
                v-model="item.date"
              />
            </div>
            <div
              class="form-group"
            >
              <label>
                {{ $t("Вид ПЗА") }}:
              </label>
              <v-select
                  id="developer"
                  item-value="transName"
                  item-text="transName"
                  :items="kindByLaws"
                  v-model="item.kind_by_law"
                  input="transName"
                  outlined
                  rounded
                  dense
              ></v-select>
            </div>
            <div
              class="form-group"
            >
              <label>
                {{ $t("Наименование закона") }}:
              </label>
              <v-textarea
                v-model="item.name"
                outlined
              />
            </div>
            <div
              class="form-group"
            >
              <label>
                {{ $t("Код проекта") }}:
              </label>
              <v-textarea
                v-model="item.link"
                outlined
              />

            </div>
            <div v-if="item.link" class="mb-2" style="display:flex; justify-content: space-between">
              <span></span>
              <button
                type="button"
                class="btn btn-default text-right"
                @click="fillById(index, item.link)"
              >
                {{ $t('Найти') }}
              </button>
            </div>
          </div>
          <div v-if="item.norm_stage == 4">
            <div
              class="form-group"
            >
              <label>
                {{ $t("Дата исходящего документа") }}:
              </label>
              <BaseDate
                v-model="item.date"
              />
            </div>
            <div
              class="form-group"
            >
              <label>
                {{ $t("Название ПЗА") }}:
              </label>
              <v-textarea
                v-model="item.name"
                outlined
              />
            </div>
            <div
              class="form-group"
            >
              <label>
                {{ $t("Номер документа") }}:
              </label>
              <v-text-field
                v-model="item.number"
                type="number"
                outlined
                rounded
                dense
              />
            </div>
          </div>
          <div v-if="item.norm_stage == 5">
            <div
              class="form-group"
            >
              <label>
                {{ $t("Дата принятия") }}:
              </label>
              <BaseDate
                v-model="item.date"
              />
            </div>
            <div
              class="form-group"
            >
              <label>
                {{ $t("Номер") }}:
              </label>
              <v-text-field
                v-model="item.cbd_number"
                outlined
              />
            </div>
            <div
              class="form-group"
            >
              <label>
                {{ $t("Название ПЗА") }}:
              </label>
              <v-textarea
                v-model="item.name"
                outlined
              />
            </div>
            <div
              class="form-group"
            >
              <label>
                {{ $t("код ЦБД") }}:
              </label>
              <v-text-field
                v-model="item.cbd_link"
                outlined
              />
              <div
                class="cbd-search__button"
                @click="getCbd(item)"
              >
                Поиск
              </div>
            </div>
          </div>
        </div>
        <div class="stage-modal__new"
        v-if="addStage">
          <div
            class="stage-modal__add"
            @click="add"
          >
            +
          </div>
          Добавить еще
        </div>
      </div>
      <div
        class="stage-modal__buttons"
        v-if="stageSelected"
      >
        <div
          class="button save"
          @click="save"
        >
          {{ $t('Сохранить') }}
        </div>
        <div
          class="button cancel"
          @click="cancel"
        >
          {{ $t('Отмена') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import BaseDate from '@/components/widget/BaseDate.vue'
  import LAW from '@/model/law'
  import NPA from '@/model/npa'

  export default {
    name: 'LawNormViewStageModal',
    components: {
      BaseDate
    },

    props: {
      stages: {
        type: Array,
        requried: true
      },
      kindByLaws: {
        type: Array,
        required: true
      },
      stage: {
        type: Object,
        required: false,
        default: []
      }
    },
    mounted: function() {
      document.getElementById('stage-modal__button-parent').focus();
      this.form = JSON.parse(JSON.stringify(this.stage.data));
      this.stageSelected = this.stage.stage.id
    },

    watch: {
      stage: function(newVal) {
        if (newVal) {
          console.log(newVal)
          this.form = newVal
        }
      }
    },

    data () {
      return {
        stageSelected: null,
        form: [],
        addStage: true
      }
    },

    computed: {
      stageDataList () {
        return {

        }
      }
    },

    methods: {
      getCbd (item) {
        LAW.getDocumentByCode(item.cbd_link).then((response) => {
          item.name = response.data.Name.Rus
          item.date = response.data.DateAdopted
          item.cbd_number = response.data.Number
        })
      },
      changeStage () {
        this.form = []
        this.selectForm()
      },

      selectForm () {
        if (this.stageSelected == 1) {
          this.addStage = false
          this.form.push({
                        norm_stage: this.stageSelected,
                        date: null,
                        reason: ''
                      })
        } else {
          this.addStage = true
        }

        if (this.stageSelected == 2) {
          this.form.push({
                        norm_stage: this.stageSelected,
                        date: null,
                        kind_by_law: ''
                      })
        }

        if (this.stageSelected == 3) {
          this.form.push({
                        norm_stage: this.stageSelected,
                        date: '',
                        name: '',
                        kind_by_law: '',
                        link: ''
                      })
        }

        if (this.stageSelected == 4) {
          this.form.push({
                        norm_stage: this.stageSelected,
                        date: '',
                        name: '',
                        number: ''
                      })
        }

        if (this.stageSelected == 5) {
          this.form.push({
              norm_stage: this.stageSelected,
              date: '',
              name: '',
              cbd_number: '',
              cbd_link:''
          })
        }
      },

      removeItem (index) {
        this.form.splice(index, 1)
      },

      save () {
        this.$emit('save', this.form)
      },

      cancel () {
        this.$emit('cancel')
      },

      add () {
        this.selectForm()
      },

      fillById (index, npa_project_id) {
        NPA.getDataFromNpaById(npa_project_id).then((response) => {
          this.form[index].date = response.data.publish_date
          this.form[index].name = response.data.transName
        }).catch(() => {

        })
      },
    }
  }
</script>
<style lang="scss">
  .stage-modal {
    position: fixed;
    width: 100%;
    height: 100vh;
    background-color: rgb(83,74,75, 0.4);
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;

    .form-item {
      border-top: 1px solid silver;
      padding-top: 20px;
      max-height: 100%;

      &__remove-button {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
      }
    }

    &__new {
      border-top: 1px solid silver;
      padding-top: 20px;
      display: flex;
      align-items: center;
    }

    &__add {
      margin-right: 20px;
      width: 38px;
      height: 38px;
      border-radius: 50px;
      border: 1px solid #575555;
      font-weight: 600;
      font-size: 30px;
      line-height: 32px;
      color: #575555;
      text-align: center;
      cursor: pointer;
    }

    &__button-parent {
      position: relative;
      height: 20px;
      margin: 20px 0;
      width: 100%;
    }

    &__button {
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
    }

    &__buttons {
      display: flex;
      margin: auto;
      margin-top: 20px;

      .button {
        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
        padding: 5px 50px;
        cursor: pointer;
      }

      .save {
        background-color:#2096f3;
        margin-right: 10px;
        color: #fff;
      }

      .cancel {
        margin-left: 10px;
      }
    }

    &__block {
      padding: 0 30px 30px 30px;
      background-color: #fff;
      width: 600px;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      display: flex;
      flex-direction: column;

      .form-group {
        display: flex;
        align-items: center;

        label {
          margin-right: 10px;
          padding-left: 10px;
          min-width: 150px;
        }
      }
    }
  }

  .cbd-search__button {
    background: #cccccc;
    padding: 5px 40px;
    margin-left: 10px;
    border-radius: 5px;
    cursor: pointer;
  }
</style>
